var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vTable',{attrs:{"data":_vm.datalist,"border":"","columns":_vm.columnsList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }